import { useMutation } from '@tanstack/react-query'
import { logout } from '../../../../apis/auth'

/**
 * ログアウト Mutation hook
 *
 * ログアウトAPIを呼び出す。
 * 成功時はlocalStorage/sessionStorageのクリアとリダイレクトを呼び出し元で行う。
 */
export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: () => logout(),
  })
}
